module.exports = __webpack_public_path__ + "img/atalanta.57f46080.png";